import Vue from 'vue'
import Vuex from 'vuex'
import {loadStorage,saveStorage,loadSessionStorage,saveSessionStorage} from '@/common/cache'

Vue.use(Vuex)

export const DEFAULT_USER = {"myId":0,"city":"","country":"","expiresDate":1656926296,"headImgUrl":"https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLGcicxTnY1VRFYevibwQlMico9vwLBBaIHYb2GHrYZEHJibiawicmfaA03gdx6qqX2aA87eFRhcYcJt9cg/132","nickname":"有条有理","openid":"orv4hv5QnVyWhYtiVYEmy0ppMJLs","province":"","sex":0}
export const SET_TEMP = 'TEMP'
export const SET_USER = 'USER'
export const SET_BANNER  = 'BANNER'
export const SET_VISITED = 'VISITED'
export const SET_CODELIST  = 'CODELIST'
export const SET_PROPERTIES  = 'PROPERTIES'
export const SET_MYSTATUS = 'MYSTATUS'
export const SET_MYCOLLECT = 'MYCOLLECT'
export const SET_MYCART = 'MYCART'


export default new Vuex.Store({
  state: {
    temp: loadSessionStorage(SET_TEMP, ''),
    user: (process.env.NODE_ENV=='production' && window.location.href.startsWith('https://www.dushicun.cn'))?JSON.parse(loadStorage(SET_USER, '{}')):DEFAULT_USER,
    banner: JSON.parse(loadSessionStorage(SET_BANNER, '{}')),
    visited: JSON.parse(loadSessionStorage(SET_VISITED, '{}')),
    codelist: JSON.parse(loadSessionStorage(SET_CODELIST, '{}')),
    properties: JSON.parse(loadSessionStorage(SET_PROPERTIES, '{}')),
    mystatus: loadSessionStorage(SET_MYSTATUS, 0),
    mycollect: JSON.parse(loadSessionStorage(SET_MYCOLLECT, '[]')),
    mycart: JSON.parse(loadSessionStorage(SET_MYCART, '[]')),
  },
  mutations: {
    temp(state, value) {
      saveSessionStorage(SET_TEMP,value)
      state.temp = value
    },
    user(state, value) {
      saveStorage(SET_USER,JSON.stringify(value))
      state.user = value
    },
    banner(state, value) {
      saveSessionStorage(SET_BANNER,JSON.stringify(value))
      state.banner = value
    },
    visited(state, value) {
      saveSessionStorage(SET_VISITED,JSON.stringify(value))
      state.visited = value
    },
    codelist(state, value) {
      saveSessionStorage(SET_CODELIST,JSON.stringify(value))
      state.codelist = value
    },
    properties(state, value) {
      saveSessionStorage(SET_PROPERTIES,JSON.stringify(value))
      state.properties = value
    },
    mystatus(state, value) {
      saveSessionStorage(SET_MYSTATUS,value)
      state.mystatus = value
    },
    mycollect(state, value) {
      saveSessionStorage(SET_MYCOLLECT,JSON.stringify(value))
      state.mycollect = value
    },
    mycart(state, value) {
      saveSessionStorage(SET_MYCART,JSON.stringify(value))
      state.mycart = value
    }
  },
  // this.$store.dispatch('loginCode','123')
  actions: {
    temp(state,value) {
      state.commit('temp',value);
    },
    user(state,value) {
      state.commit('user',value);
    },
    banner(state,value) {
      state.commit('banner',value);
    },
    visited(state, value) {
      state.commit('visited',value);
    },
    codelist(state,value) {
      state.commit('codelist',value);
    },
    properties(state,value) {
      state.commit('properties',value);
    },
    mystatus(state,value) {
      state.commit('mystatus',value);
    },
    mycollect(state,value) {
      state.commit('mycollect',value);
    },
    mycart(state,value) {
      state.commit('mycart',value);
    }
  },
  // this.$store.getters.loginCode
  getters: {
    temp(state){
      return state.temp;
    },
    user(state) {
      return state.user;
    },
    userId(state){
      return state.user['myId'];
    },
    banner(state) {
      return state.banner
    },
    visited(state) {
      return state.visited
    },
    codelist(state) {
      return state.codelist
    },
    properties(state) {
      return state.properties
    },
    mycollect(state) {
      return state.mycollect
    },
    mycart(state) {
      return state.mycart
    },
    isMyInit(state){
      if(state.mystatus==1){
        return true
      } else {
        return false
      }
    },
    isSysInit(state) {
      if(Object.keys(state.banner).length>0 && Object.keys(state.codelist).length>0){
        return true
      } else {
        return false
      }
    },
    isLogin(state){
      if(Object.keys(state.user).length>0){
        return true
      } else {
        return false
      }
    }
  },
})
